














































































































































import { Component, Vue, PropSync, Prop } from 'vue-property-decorator';
import { UsersApi, User } from '@/api';
import userSuggest from '@/components/form pickers/userSuggest.vue';
import Toast from '@/components/display/toast.vue';
import { email, requiredIf, minLength, required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import TitleMixin from '@/mixins/title-mixin';
import { canAddUsers } from '@/services/user-service';
import { startCase } from 'lodash';
import UserPhoneInput from '@/components/form pickers/UserPhoneInput.vue';

@Component({
	methods: { startCase },
	components: {
		userSuggest,
		UserPhoneInput,
	},
	validations: {
		localUser: {
			firstName: { required },
			email: { required, email },
			phone: { minLength: minLength(6) },
			permission: {
				required: requiredIf(function() {
					return 'permission' in this.localUser;
				}),
			},
			role: {
				required: requiredIf(function() {
					return 'role' in this.localUser;
				}),
			},
		},
	},
	mixins: [validationMixin, TitleMixin],
})
export default class AddUser extends Vue {
	public get canAddUsers(): boolean {
		return canAddUsers(this.nUsers, this.legacySubscriptionItem);
	}
	@PropSync('user')
	public localUser!: any;

	@Prop(String)
	public readonly modalTitle!: string;

	@Prop(Number)
	public readonly productId!: number;

	@Prop(Number)
	public readonly orgId!: number;

	@Prop(String)
	public readonly orgType!: string;

	public roleOptions = [
		{ value: 'partner.admin', text: 'Partner Admin', type: 'partner' },
		{ value: 'partner.user', text: 'Partner Read Only', type: 'partner' },
		{ value: 'org.admin', text: 'Organisation Admin', type: 'org' },
	];

	public permissionOptions = [
		{ value: 'product.user', text: 'User' },
		{ value: 'product.admin', text: 'Admin' },
	];

	public phoneValid: boolean = true;

	@Prop(Number)
	private readonly nUsers!: number;

	@Prop()
	private readonly legacySubscriptionItem!: { plan: string; trialPlan: string } | undefined;

	private usersApi = new UsersApi();

	public isValid(field) {
		return field && field.$dirty ? !field.$invalid : null;
	}

	public clearlocalUser() {
		if ('permission' in this.localUser) {
			this.localUser.permission = '';
		}
		if ('role' in this.localUser) {
			this.localUser.role = '';
		}
		this.localUser.id = '';
		this.localUser.firstName = '';
		this.localUser.lastName = null;
		this.localUser.email = '';
		this.localUser.phone = '';
		this.$v.$reset();
	}

	public onPhoneChanged(phone: string | null, phoneValid: boolean): void {
		this.localUser.phone = phone;
		this.phoneValid = phoneValid;
	}

	public async addUser(bvModalEvt: Event) {
		bvModalEvt.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid || this.phoneValid === false) {
			return;
		}
		const user = this.localUser;
		let response;

		if (!this.localUser.id) {
			try {
				response = await this.usersApi.createUser({ data: user });
				this.localUser.id = response.data.data.id;
			} catch (e) {
				const error = e.response.data.errors;
				new Toast().makeToast(
					JSON.stringify(error),
					'Error Creating Unassigned User',
					'danger',
					true,
				);
				return;
			}
		}

		if (this.productId) {
			const permission = {
				org: { id: parseInt(this.orgId, 10) },
				productId: parseInt(this.productId, 10),
				permission: this.localUser.permission,
				action: 'attach',
			};
			try {
				response = await this.usersApi.userPermission(parseInt(this.localUser.id, 10), {
					data: permission,
				});
			} catch (e) {
				const error = e.response.data.errors;
				new Toast().makeToast(
					JSON.stringify(error),
					'Error Adding User Permission',
					'danger',
					true,
				);
				return;
			}
		} else if (this.orgType === 'org' || this.orgType === 'partner') {
			if (this.localUser.id) {
				const role = {
					orgId: parseInt(this.orgId, 10),
					action: 'attach',
					role: this.localUser.role,
				};
				try {
					response = await this.usersApi.userRoles(parseInt(this.localUser.id, 10), { data: role });
				} catch (e) {
					const error = e.response.data.errors;
					new Toast().makeToast(JSON.stringify(error), 'Error Adding User Role', 'danger', true);
					return;
				}
			}
		}
		new Toast().makeToast(`${this.modalTitle} success`, 'Successful', 'success');
		this.$emit('userSuccess');
		this.$bvModal.hide('add-user-modal');
	}
}
